<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お客さま情報の変更</HeadingOne>

    <WizardGroup class="_mb-md-60 _mb-sm-20">
      <MainWizard :active-index="2" type="userinfo"></MainWizard>
    </WizardGroup>

    <p>
      以下の内容で変更しました。<br />
      その他のお客さま情報を変更する場合は、「お客さま情報を確認する」より変更する箇所をご選択のうえお手続きください。
    </p>

    <section>
      <TableGroup>
        <HeadingTwo class="_mt-50">お客さま情報</HeadingTwo>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader>
                お客さま番号
                <ChangeBadgeIcon></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.account_id }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                氏名<small>（漢字）</small>
                <ChangeBadgeIcon></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.name_kanji }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                氏名<small>（フリガナ）</small>
                <ChangeBadgeIcon></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.name_kana }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                生年月日
                <ChangeBadgeIcon></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayBth(userData.bth) }}
              </TableData>
            </TableRow>
            <!--<TableRow>-->
            <!--<TableHeader>-->
            <!--性別-->
            <!--<ChangeBadgeIcon></ChangeBadgeIcon>-->
            <!--</TableHeader>-->
            <!--<TableData>-->
            <!--{{displaySex}}-->
            <!--</TableData>-->
            <!--</TableRow>-->
            <template v-if="auUser(userData.id_type)">
              <TableRow v-if="hasPhoneAu">
                <TableHeader>
                  au携帯電話番号または<br />UQ mobile 電話番号
                  <ChangeBadgeIcon></ChangeBadgeIcon>
                </TableHeader>
                <TableData>
                  {{
                    displayPhoneAu(
                      userData.phone_au_1,
                      userData.phone_au_2,
                      userData.phone_au_3
                    )
                  }}
                </TableData>
              </TableRow>
            </template>
            <TableRow>
              <TableHeader>
                電話番号<small>（その他）</small>
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="[
                    'phone_mobile_1',
                    'phone_mobile_2',
                    'phone_mobile_3',
                  ]"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{
                  displayPhoneMobile(
                    hasPhoneMobile,
                    userData.phone_mobile_1,
                    userData.phone_mobile_2,
                    userData.phone_mobile_3
                  )
                }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                毎月のご返済日
                <ChangeBadgeIcon></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                毎月{{ userData.contractual_repayment_cycle }}日
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>

        <HeadingTwo class="_mt-50">ご自宅情報</HeadingTwo>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader>
                郵便番号
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['postcode']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                〒{{ displayPostcode(userData.postcode) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                ご住所<small>（漢字）</small>
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="[
                    'address_region',
                    'address_city',
                    'address_street',
                    'address_building',
                  ]"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{
                  displayAddress(
                    userData.address_region,
                    userData.address_city,
                    userData.address_street,
                    userData.address_building
                  )
                }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                ご住所<small>（フリガナ）</small>
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['address_kana']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.address_kana }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                お住まいの種類
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['home_type']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayHomeType(userData.home_type) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                居住開始年月
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['nky_ngt']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayNkyNgt(userData.nky_ngt) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                住宅ローンもしくは家賃のお支払い<small>（月額）</small>
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['rent_loan_amount']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayRentLoanAmount(userData.rent_loan_amount) }}
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader>
                ご家族（配偶者さま）
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['marriage_status']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayMarriageStatus(userData.marriage_status) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                ご家族（お子さま）
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['number_of_children']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayNumberOfChildren(userData.number_of_children) }}
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <BtngroupSingle class="_mb-md-120 _mb-sm-40">
        <BtnMain class="-main" router-name="mb023">
          お客さま情報を確認する
        </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { diffKeysGet } from "@/utils/ChangeIcon";
import { goToErrorPage } from "@/utils/Other";
import {
  auUser,
  displayBth,
  displayPhoneAu,
  displayPhoneMobile,
  displayPostcode,
  displayAddress,
  displayHomeType,
  displayNkyNgt,
  displayRentLoanAmount,
  displayMarriageStatus,
  displayNumberOfChildren,
  setHasPhoneAu,
  setHasPhoneMobile,
} from "@/utils/UserData";

import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import ChangeBadgeIcon from "@/components/badges/ChangeBadgeIcon";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Tem017",
  components: {
    ChangeBadgeIcon,
    TableGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    HeadingTwo,
    BtnMain,
    BtngroupSingle,
    WizardGroup,
    MainWizard,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お客さま情報の変更｜お客さま情報の確認・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      auUser,
      displayBth,
      displayPhoneAu,
      displayPhoneMobile,
      displayPostcode,
      displayAddress,
      displayHomeType,
      displayNkyNgt,
      displayRentLoanAmount,
      displayMarriageStatus,
      displayNumberOfChildren,
      setHasPhoneAu,
      setHasPhoneMobile,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "お客さま情報の変更",
          active: true,
        },
      ],
      hasPhoneMobile: false,
      hasPhoneAu: false,
      userData: {
        id_type: "",
        account_id: "",
        name_kanji: "",
        name_kana: "",
        firstname_kana: "",
        firstname_kanji: "",
        lastname_kana: "",
        lastname_kanji: "",
        bth: "",
        sex: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        repayment_date: "",
        contractual_repayment_cycle: "",
        postcode: "",
        address_region: "",
        address_city: "",
        address_street: "",
        address_building: "",
        address_kana: "",
        home_type: "",
        nky_ngt: "",
        rent_loan_amount: "",
        marriage_status: "",
        number_of_children: "",
      },
      diffKeys: [],
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
          this.setHasPhoneAu();
          this.setHasPhoneMobile();
          this.hasPhoneAu = setHasPhoneAu(
            this.userData.phone_au_1,
            this.userData.phone_au_2,
            this.userData.phone_au_3
          );
          this.hasPhoneMobile = setHasPhoneMobile(
            this.userData.phone_mobile_1,
            this.userData.phone_mobile_2,
            this.userData.phone_mobile_3
          );
        })
        .catch((error) => {
          goToErrorPage(error);
        });

      diffKeysGet()
        .then((res) => {
          this.diffKeys = res;
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style scoped></style>
